import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { BusinessProvider } from './context/BusinessContext';
import AppShell from './components/AppShell';
import SignIn from './pages/SignIn';
import Dashboard from './pages/Dashboard';
import KioskBoard from './pages/KioskBoard';
import Invoices from './pages/Invoices';
import Deposits from './pages/Deposits';
import Quotes from './pages/Quotes';
import Customers from './pages/Customers';
import Items from './pages/Items';
import Contracts from './pages/Contracts';
import Approvals from './pages/Approvals';
import Agreements from './pages/Agreements';
import Expenses from './pages/Expenses';
import JobsRoute from './pages/JobsRoute';
import Users from './pages/Users';
import Permissions from './pages/Permissions';
import Audit from './pages/Audit';
import Import from './pages/Import';
import Export from './pages/Export';
import StripeSettings from './pages/StripeSettings';
import Backups from './pages/Backups';
import W9 from './pages/W9';
import Reconcile from './pages/Reconcile';
import Reports from './pages/Reports';
import Statements from './pages/Statements';
import Payments from './pages/Payments';
import BusinessProfile from './pages/BusinessProfile';
import Accounts from './pages/Accounts';
import Bills from './pages/Bills';
import ServiceReports from './pages/ServiceReports';

export default function App() {
  const { status, can, user } = useAuth();

  if (status === 'loading') return <div className="boot">Loading…</div>;
  if (status !== 'authed') return <SignIn />;

  return (
    <BusinessProvider>
      <BrowserRouter>
        <AppShell>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/board" element={<KioskBoard />} />
            <Route path="/invoices" element={<Invoices />} />
            {can('payments.view') && <Route path="/payments" element={<Payments />} />}
            <Route path="/deposits" element={<Deposits />} />
            {can('reconciliations.view') && <Route path="/reconcile" element={<Reconcile />} />}
            {can('reports.view') && <Route path="/reports" element={<Reports />} />}
            {can('invoices.view') && <Route path="/statements" element={<Statements />} />}
            <Route path="/quotes" element={<Quotes />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/items" element={<Items />} />
            <Route path="/contracts" element={<Contracts />} />
            <Route path="/expenses" element={<Expenses />} />
            <Route path="/bills" element={<Bills />} />
            {can('expenses.view') && <Route path="/approvals" element={<Approvals />} />}
            {can('contracts.view') && <Route path="/agreements" element={<Agreements />} />}
            <Route path="/jobs" element={<JobsRoute />} />
            {can('service_reports.view') && <Route path="/service-reports" element={<ServiceReports />} />}
            {user?.role === 'admin' && <Route path="/settings/accounts" element={<Accounts />} />}
            {can('users.manage') && <Route path="/users" element={<Users />} />}
            {can('permissions.manage') && <Route path="/permissions" element={<Permissions />} />}
            {can('audit.view') && <Route path="/audit" element={<Audit />} />}
            {can('data.import') && <Route path="/import" element={<Import />} />}
            {can('data.export') && <Route path="/export" element={<Export />} />}
            {user?.role === 'admin' && <Route path="/settings/business" element={<BusinessProfile />} />}
            {user?.role === 'admin' && <Route path="/settings/payments" element={<StripeSettings />} />}
            {user?.role === 'admin' && <Route path="/settings/backups" element={<Backups />} />}
            {user?.role === "admin" && <Route path="/w9" element={<W9 />} />}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AppShell>
      </BrowserRouter>
    </BusinessProvider>
  );
}
